import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomerHelperService {
  splitFullName(fullName: string) {
    const splitName = fullName.split(' ');
    let firstName = '';
    let lastName = '';
    if (splitName.length > 1) {
      lastName = splitName.pop()!;
      firstName = splitName.join(' ');
    } else {
      firstName = fullName;
    }
    return { firstName, lastName };
  }
}
